import { connect } from 'react-redux';

import {
    CategoryConfigurableAttributesContainer as SourceCategoryConfigurableAttributesContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
} from 'SourceComponent/CategoryConfigurableAttributes/CategoryConfigurableAttributes.container';

/** @namespace AdvoxBasic/Component/CategoryConfigurableAttributes/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    // TODO extend mapStateToProps
});

/** @namespace AdvoxBasic/Component/CategoryConfigurableAttributes/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    // TODO extend mapDispatchToProps
});

/** @namespace AdvoxBasic/Component/CategoryConfigurableAttributes/Container/CategoryConfigurableAttributesContainer */
export class CategoryConfigurableAttributesContainer extends SourceCategoryConfigurableAttributesContainer {
    state = {
        searchFilterValue: {},
    };

    containerFunctions = {
        ...this.containerFunctions,
        handleSearchFilterValueChange: this.handleSearchFilterValueChange.bind(this),
    };

    containerProps() {
        const { searchFilterValue } = this.state;

        return {
            ...super.containerProps(),
            searchFilterValue,
        };
    }

    handleSearchFilterValueChange(inputValue, attribute_code) {
        this.setState((prevState) => ({
            searchFilterValue: {
                ...prevState.searchFilterValue,
                [attribute_code]: inputValue,
            },
        }));
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryConfigurableAttributesContainer);
